import { useEffect, useState } from 'react';
import type { DashboardSectionIndex, Me } from './api';
import { MarketingCampaignPanel } from './Kampanyalar';
import { MarketingRecoveryPanel } from './GeriKazanim';
import { MarketingConsentPanel } from './Pazarlama';
import { DashboardPanels } from './Dashboard';
import { AiPaneli, Seo } from './Seo';
import { PZ, SEO } from './metin/seo';
import { PZ_SEKMELER, sekmeGorunur, pazarlamaAdres, pazarlamaDurumu } from './pazarlama-durum';
import './web-sitesi.css';
import './seo.css';

export function PazarlamaSekmeleri({ me, sections }: { me: Me; sections: DashboardSectionIndex | null }) {
  const [durum, setDurum] = useState(pazarlamaDurumu);
  // Sekmeyi gizlemek yetkilendirme değildir; her uç sunucuda yeniden denetlenir.
  const gorunen = PZ_SEKMELER.filter((s) => sekmeGorunur(s, me.permissions));
  const secili = gorunen.find((s) => s === durum.sekme) ?? 'genel';
  useEffect(() => { if (secili) pazarlamaAdres(secili, durum.alt); }, [secili, durum.alt]);
  useEffect(() => {
    const oku = () => setDurum(pazarlamaDurumu());
    window.addEventListener('popstate', oku);
    return () => window.removeEventListener('popstate', oku);
  }, []);
  useEffect(() => {
    const dugme = document.getElementById(`pz-tab-${secili}`);
    const cubuk = dugme?.parentElement;
    if (!dugme || !cubuk) return;
    // Yalnız sekme çubuğu kayar; sayfa ve gizlenen üst şerit yerinde kalır.
    const goster = () => {
      if (cubuk.clientWidth === 0) return;
      const sol = cubuk.scrollLeft + dugme.getBoundingClientRect().left - cubuk.getBoundingClientRect().left;
      cubuk.scrollLeft = Math.max(0, sol - 8);
    };
    goster();
    const gozlem = new ResizeObserver(goster);
    gozlem.observe(cubuk);
    return () => gozlem.disconnect();
  }, [secili]);
  return <div className="seo-shell">
    <div className="ws"><nav className="subtabs maintabs" role="tablist" aria-label={SEO.sekmeler} data-testid="pz-sekmeler">
      {gorunen.map((s, i) => <button type="button" role="tab" id={`pz-tab-${s}`} aria-controls="pz-panel" aria-selected={s === secili} tabIndex={s === secili ? 0 : -1} data-testid={`pz-sekme-${s}`} key={s}
        onClick={() => setDurum((d) => ({ ...d, sekme: s }))}
        onKeyDown={(e) => {
          const n = e.key === 'ArrowRight' ? (i + 1) % gorunen.length : e.key === 'ArrowLeft' ? (i + gorunen.length - 1) % gorunen.length : e.key === 'Home' ? 0 : e.key === 'End' ? gorunen.length - 1 : -1;
          const next = gorunen[n];
          if (!next) return;
          e.preventDefault(); setDurum((d) => ({ ...d, sekme: next })); document.getElementById(`pz-tab-${next}`)?.focus();
        }}>{PZ[s]}</button>)}
    </nav></div>
    <div id="pz-panel" role="tabpanel" tabIndex={0} aria-label={PZ[secili]} className="workflow-stack">
      {secili === 'genel' && <DashboardPanels sections={sections} only="MARKETING" />}
      {secili === 'ai' && <AiPaneli me={me} />}
      {secili === 'kampanya' && <MarketingCampaignPanel me={me} />}
      {secili === 'geri-kazanim' && <MarketingRecoveryPanel me={me} />}
      {secili === 'riza' && <MarketingConsentPanel me={me} />}
      {secili === 'seo' && <Seo me={me} alt={durum.alt} onAlt={(alt) => setDurum((d) => ({ ...d, alt }))} />}
    </div>
  </div>;
}
